import React, { Suspense } from 'react';
import { RecurlyPayPal } from '../PayPal/RecurlyPayPal';
import { RecurlyApplePay } from '../ApplePay/RecurlyApplePay';
import { RecurlyGooglePay } from '../GooglePay/RecurlyGooglePay';
import { RecurlyVenmo } from '../Venmo/RecurlyVenmo';
import LoadingIndicator from '../LoadingIndicator';
import { ThirdPartyButtonContainer } from '../PaymentButtons/ThirdPartyButtonContainer';
import { Divider, PaymentButtonsWrapper } from '../PaymentButtons/styled';
import { useAppSelector } from '../../hooks/useAppSelector';
import { configSelector, paymenFormSelector } from '../../redux/ConfigState/ConfigState.selectors';
import { getPaymentFieldLabelText } from '../PaymentForm/helpers';
import { PaymentFormDataFields } from '../UserAddress/constants';
import { PaymentMethods } from '../../constants/PaymentTypes';
import { countTotalShownButtons, isVenmoEnabled, shouldShowDivider } from '../PaymentButtons/helper';
import { DataTestAttributes } from '../../constants/DataTestAttributes';
import { getString } from '../../constants/Strings';
import { isWindowDefined } from '@chegg/utils';
import { isExternalDomain } from '@chegg/commerce-utils';
export var PaymentButtons = /*#__PURE__*/React.memo(function () {
  var _supportedPaymentMeth;
  var config = useAppSelector(configSelector);
  var paymentForm = useAppSelector(paymenFormSelector);
  var supportedPaymentMethods = config.supportedPaymentMethods,
    country = config.country,
    applepayVisible = config.applepayVisible,
    googlepayVisible = config.googlepayVisible,
    venmoVisible = config.venmoVisible,
    priceSummary = config.priceSummary,
    isPrimary = config.isPrimary;
  var paypalEnabled = (supportedPaymentMethods === null || supportedPaymentMethods === void 0 ? void 0 : supportedPaymentMethods.includes(PaymentMethods.PAYPAL)) || false;

  // Explicitly added check for isWindowDefined and isExternalDomain to avoid
  // rendering the Apple Pay button when the the domain is not chegg.com/cheggnet.com
  // This is to prevent the Apple Pay button from being rendered on external domains,
  // because Apple Pay is not supported on external domains with the current implementation.
  // Jira ticket: https://chegg.atlassian.net/browse/GROWTH-2202
  var applepayEnabled = (supportedPaymentMethods === null || supportedPaymentMethods === void 0 ? void 0 : supportedPaymentMethods.includes(PaymentMethods.APPLEPAY)) && applepayVisible && isWindowDefined && !isExternalDomain(window.location.hostname) || false;
  var googlepayEnabled = (supportedPaymentMethods === null || supportedPaymentMethods === void 0 ? void 0 : supportedPaymentMethods.includes(PaymentMethods.GOOGLE_PAY)) && googlepayVisible && isWindowDefined && !isExternalDomain(window.location.hostname) || false;
  var venmoEnabled = !!(supportedPaymentMethods && venmoVisible && country) && isVenmoEnabled(supportedPaymentMethods, venmoVisible, country);
  var creditcardEnabled = (_supportedPaymentMeth = supportedPaymentMethods === null || supportedPaymentMethods === void 0 ? void 0 : supportedPaymentMethods.includes(PaymentMethods.CREDITCARD)) !== null && _supportedPaymentMeth !== void 0 ? _supportedPaymentMeth : false;
  var buttonFlags = [paypalEnabled, applepayEnabled, googlepayEnabled, venmoEnabled];
  var showDivider = shouldShowDivider(buttonFlags, creditcardEnabled);
  var totalShownButtons = countTotalShownButtons(buttonFlags);
  // apply a key to the google pay button to force an umount and remount with updated price
  // this is due to a limitation with how Recurly.js integrates with google pay GROWTH-2234
  var googlePayKey = "".concat(priceSummary === null || priceSummary === void 0 ? void 0 : priceSummary.currency, "_").concat(priceSummary === null || priceSummary === void 0 ? void 0 : priceSummary.total, "_").concat(country, "_").concat(isPrimary);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(LoadingIndicator, null)
  }, /*#__PURE__*/React.createElement(PaymentButtonsWrapper, {
    "data-test": DataTestAttributes.PAYMENT_BUTTONS
  }, paypalEnabled && /*#__PURE__*/React.createElement(ThirdPartyButtonContainer, {
    itemsInRow: totalShownButtons
  }, /*#__PURE__*/React.createElement(RecurlyPayPal, null)), applepayEnabled && /*#__PURE__*/React.createElement(ThirdPartyButtonContainer, {
    itemsInRow: totalShownButtons
  }, /*#__PURE__*/React.createElement(RecurlyApplePay, null)), googlepayEnabled && /*#__PURE__*/React.createElement(ThirdPartyButtonContainer, {
    itemsInRow: totalShownButtons
  }, /*#__PURE__*/React.createElement(RecurlyGooglePay, {
    key: googlePayKey
  })), venmoEnabled && /*#__PURE__*/React.createElement(ThirdPartyButtonContainer, {
    itemsInRow: totalShownButtons
  }, /*#__PURE__*/React.createElement(RecurlyVenmo, null)))), showDivider && /*#__PURE__*/React.createElement(Divider, {
    "data-test": DataTestAttributes.DIVIDER
  }, /*#__PURE__*/React.createElement("span", null, getPaymentFieldLabelText(paymentForm, PaymentFormDataFields.OR) || getString('APP.DIVIDER.OR'))));
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/Recurly/PaymentButtons.js
// module id = 4625
// module chunks = 11